export { EdgeVM as RuntimeEdge } from '@runtime-edge/vm'
